/*
 * @Author: YuanYuan
 * @Date: 2025-08-26 14:39:06
 * @LastEditTime: 2025-10-30 15:21:10
 * @Description: 渠道管理接口集合
 */
const prefix = process.env.VUE_APP_API_PREFIX

export default [
  {
    name: 'partner',
    path: `${prefix}/distributor/partner`,
    method: 'get',
    params: {},
    desc: '渠道商-合作伙伴类型'
  },
  {
    name: 'overview',
    path: `${prefix}/distributor/detail/top`,
    method: 'get',
    params: {},
    desc: '渠道商-概览数据'
  },
  {
    name: 'info',
    path: `${prefix}/distributor/getCurrent`,
    method: 'get',
    params: {},
    desc: '渠道商信息管理详情'
  },
  {
    name: 'updateInfo',
    path: `${prefix}/distributor/update`,
    method: 'post',
    params: {},
    desc: '保存渠道商信息'
  },
  {
    name: 'orderList',
    path: `${prefix}/order/distributorList`,
    method: 'get',
    params: {},
    desc: '客户订单列表'
  },
  {
    name: 'updatePrice',
    path: `${prefix}/order/changePrice`,
    method: 'post',
    params: {
      orderId: '',
      price: ''
    },
    desc: '修改订单价格'
  },
  {
    name: 'customerList',
    path: `${prefix}/distributor/customer/page/list`,
    method: 'post',
    params: {
      page: 1,
      limit: 10,
      keyword: '',
      type: 'cms'
    },
    desc: '渠道商客户管理列表'
  },
  {
    name: 'customerInfo',
    path: `${prefix}/user/get`,
    method: 'get',
    params: {
      id: ''
    },
    desc: '客户账号信息'
  },
  {
    name: 'transfer',
    path: `${prefix}/user/transfer`,
    method: 'post',
    params: {
      userId: '',
      verifyCode: '',
      amount: '',
      password: ''
    },
    desc: '转账'
  }
]
